module.exports = __webpack_public_path__ + "img/step1-2.00bd58aa.png";